import { DropdownOptionDto } from "@/api/models/common.model";
import { ProductDependencyDto } from "@/api/product-dependencies";
import { ProductGroupDependenciesByProductType } from "@/models/product.model";
import { StorageState } from "./storage";

const getDropdownData = (state: StorageState) => {
	return ({ key }: { key: string }): DropdownOptionDto[] => {
		if (!key) return [];
		return state[key] ?? [];
	};
};

const getProductGroupsDependencies = (state: StorageState) => {
	return (): ProductGroupDependenciesByProductType => {
		return (
			state.productGroupsDependencies ?? {
				fiber: [],
				voip: [],
				mobile: []
			}
		);
	};
};

const getProductNonGroupsDependencies = (state: StorageState) => {
	return (): ProductDependencyDto[] => {
		return state.productNonGroupsDependencies ?? [];
	};
};

export default {
	getDropdownData,
	getProductGroupsDependencies,
	getProductNonGroupsDependencies
};
